import { Link } from 'react-router-dom';
import type { Post } from '@/content/posts';

function formatDate(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function PostListItem({ post }: { post: Post }) {
  return (
    <article className="group py-6 border-b border-rule last:border-b-0">
      <Link to={`/blog/${post.slug}`} className="no-underline block">
        <div className="label mb-2">
          <time dateTime={post.date}>{formatDate(post.date)}</time>
          {post.tags.length > 0 && (
            <>
              <span className="mx-2 text-rule">·</span>
              <span>{post.tags.join(' / ')}</span>
            </>
          )}
        </div>
        <h2 className="font-display text-2xl md:text-3xl font-medium leading-tight group-hover:text-accent transition-colors">
          {post.title}
        </h2>
        <p className="mt-2 text-ink-muted max-w-prose">{post.summary}</p>
      </Link>
    </article>
  );
}
